import { Pipe, PipeTransform } from '@angular/core';
import {GroupAttributeI} from '../services/product-setup.service';

@Pipe({
  name: 'groupFieldCheck'
})
export class GroupFieldCheckPipe implements PipeTransform {

  transform(field: string, fields: GroupAttributeI[]): boolean {
    if (!fields) return true;

    return fields.some(it => it.selectedAttribute === field);
  }

}
